export default __webpack_public_path__ + "assets/observatories-map.dd502f3e.png";